import React from 'react';
import { useState, useEffect, useCallback, useRef } from 'react';
import sweetalert2 from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Datatable from '../../ExtraComponents/ReusableTable2';
import ReactPaginate from "react-paginate";
import * as Yup from "yup"
import {
  getAllFeeProtector,
  runComparisonApi
} from '../../Service/FeeProtector/FeeProtectorService';

import debounce from 'lodash.debounce';
import Swal from "sweetalert2";
import { Settings, PanelTop, Wrench, GitCompare, Eye } from "lucide-react";
import * as Config from "../../Utils/Config";
import axios from "axios";
import { cleanHtmlEntities, roundNumber } from '../../Utils/CommonFun';

const FeeProtector = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const user_id = JSON.parse(localStorage.getItem("details"))?.id;

  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [InputValue, setInputValue] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isLoading, setLoading] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])



  const [feeProtectorData, setFeeProtectorData] = useState([]);
  const [statusCounts, setStatusCounts] = useState({});
  // console.log("feeProtectorData", feeProtectorData);

  const isSearchTriggered = useRef(false);

  const debounceSearch = useCallback(
    debounce((value) => {
      isSearchTriggered.current = true;
      setDebouncedSearch(value);
    }, 1000), // 1 second delay
    []
  );

  /**
   * Handle input change
   */
  const handleInputChange = (e) => {
    const value = e.target.value;

    setInputValue(value); // instant input update
    debounceSearch(value); // delayed api trigger
  };



  const getAllFeeProtectorFunction = async () => {
    const isSearch = isSearchTriggered.current;
    isSearchTriggered.current = false;
    try {
      const data = {
        agent_id: agent_id,
        user_id: user_id,
        page: currentPage,
        limit: pageSize,
        search: debouncedSearch,
      };
      if (!isSearch) setLoading(true);

      const res = await getAllFeeProtector(data);
      // console.log("res", res);
      setFeeProtectorData(res?.data ?? []);
      setStatusCounts(res?.statusCounts)
      setTotalRecords(res?.pagination?.total)
      if (!isSearch) setLoading(false);

    } catch (error) {
      if (!isSearch) setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getAllFeeProtectorFunction()
  }, [currentPage, pageSize, debouncedSearch]);



  const columns = [

    {
      name: "Client",
      width: "10%",
      selector: (row) => row?.Client?.client_name,
      sortFunction: (a, b) => {
        const nameA = (a?.Client?.client_name || "").toLowerCase();
        const nameB = (b?.Client?.client_name || "").toLowerCase();

        return nameA.localeCompare(nameB);
      },
      cell: (row) => <span style={{ fontSize: '13px' }}
      onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
      >
        {cleanHtmlEntities(row?.Client?.client_name) ?? "-"}
        </span>,
      sortable: true,
    },
     {
      name: "Client Manager",
      width: "14%",
      selector: (row) => row?.Client?.am_name,
      sortFunction: (a, b) => {
        const nameA = (a?.Client?.am_name || "").toLowerCase();
        const nameB = (b?.Client?.am_name || "").toLowerCase();

        return nameA.localeCompare(nameB);
      },
      cell: (row) => <span style={{ fontSize: '13px' }}
      onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
      >
        {row?.Client?.am_name ?? "-"}
        </span>,
      sortable: true,
    },

    {
      name: "Status",
      width: "13%",
      selector: (row) => row?.statusFeeProtector,
      sortFunction: (a, b) => {
        const valA = (a?.statusFeeProtector || "").toLowerCase().trim();
        const valB = (b?.statusFeeProtector || "").toLowerCase().trim();

        return valA.localeCompare(valB);
      },
      cell: (row) => (
        <span className={`badge ${row?.statusColor || ""}`}
        onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
        >
          {row?.statusFeeProtector || "-"}
        </span>
      ),
      sortable: true,
    },

    // {
    //   name: "CURRENT FEE",
    //   width: "13%",
    //   selector: (row) => row?.total_monthly_ongoing || 0,
    //   sortable: true,
    //   sortFunction: (a, b) => {
    //     const valA = Number(a?.total_monthly_ongoing || 0);
    //     const valB = Number(b?.total_monthly_ongoing || 0);
    //     return valA - valB;
    //   },

    //   cell: (row) => (
    //     <span onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}>
    //       £{Number(row?.total_monthly_ongoing || 0).toFixed(2)}
    //       /{row?.frequencyCode_ongoing || "-"}
    //     </span>
    //   ),
    // },
    // {
    //   name: "PROPOSED FEE",
    //   width: "15%",
    //   selector: (row) => row?.total_monthly_ongoing_new || 0,
    //   sortFunction: (a, b) => {
    //     const valA = Number(a?.total_monthly_ongoing_new || 0);
    //     const valB = Number(b?.total_monthly_ongoing_new || 0);
    //     return valA - valB;
    //   },
    //   cell: (row) =>
    //     row?.finalDriverData?.length === 0 ?
    //       <span
    //        onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
    //       > - </span>
    //       :
    //       <span className="red fee-gap-col" 
    //       onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
    //       >
    //         +£{formatNumber((row?.total_monthly_ongoing_new)?.toFixed(2)) + "/" + row?.frequencyCode_ongoing}
    //       </span>,
    //   sortable: true,
    // },
    // {
    //   name: "FEE GAP",
    //   width: "13%",
    //   selector: (row) => row?.total_monthly_ongoing_new - row?.total_monthly_ongoing || 0,
    //   sortFunction: (a, b) => {
    //     const valA = Number(a?.total_monthly_ongoing_new - a?.total_monthly_ongoing || 0);
    //     const valB = Number(b?.total_monthly_ongoing_new - b?.total_monthly_ongoing || 0);
    //     return valA - valB;
    //   },
    //   cell: (row) =>
    //     row?.finalDriverData?.length === 0 ?
    //       <span
    //        onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
    //       > - </span>
    //       :
    //       <span className="red fee-gap-col" 
    //       onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
    //       >
    //         +£{(parseFloat(row?.total_monthly_ongoing_new) - parseFloat(row?.total_monthly_ongoing))?.toFixed(2) + "/" + row?.frequencyCode_ongoing + " (" + row?.percentageIncrease_ongoing + "%)"}
    //       </span>,
    //   sortable: true,
    // },
   
     {
      name: "Current Fee",
      width: "13%",
      selector: (row) => row?.total_monthly_excluding_ongoing || 0,
      sortable: true,
      sortFunction: (a, b) => {
        const valA = Number(a?.total_monthly_excluding_ongoing || 0);
        const valB = Number(b?.total_monthly_excluding_ongoing || 0);
        return valA - valB;
      },

      cell: (row) => (
        <span onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}>
          £{roundNumber(row?.total_monthly_excluding_ongoing || 0)}
          /{row?.frequencyCode_ongoing || "-"}
        </span>
      ),
    },
    {
      name: "Proposed Fee",
      width: "15%",
      selector: (row) => row?.total_monthly_excluding_ongoing_new || 0,
      sortFunction: (a, b) => {
        const valA = Number(a?.total_monthly_excluding_ongoing_new || 0);
        const valB = Number(b?.total_monthly_excluding_ongoing_new || 0);
        return valA - valB;
      },
      cell: (row) =>
        row?.finalDriverData?.length === 0 ?
          <span
           onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
          > - </span>
          :
          <span className="red fee-gap-col" 
          onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
          >
            +£{roundNumber(row?.total_monthly_excluding_ongoing_new) + "/" + row?.frequencyCode_ongoing}
          </span>,
      sortable: true,
    },
    {
      name: "Fee Gap",
      width: "13%",
      selector: (row) => row?.total_monthly_excluding_ongoing_new - row?.total_monthly_excluding_ongoing || 0,
      sortFunction: (a, b) => {
        const valA = Number(a?.total_monthly_excluding_ongoing_new - a?.total_monthly_excluding_ongoing || 0);
        const valB = Number(b?.total_monthly_excluding_ongoing_new - b?.total_monthly_excluding_ongoing || 0);
        return valA - valB;
      },
      cell: (row) =>
        row?.finalDriverData?.length === 0 ?
          <span
           onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
          > - </span>
          :
          <span className="red fee-gap-col" 
          onClick={()=>navigate("/admin/ViewFeeProtector", { state: row })}
          >
            +£{roundNumber(roundNumber(row?.total_monthly_excluding_ongoing_new) - roundNumber(row?.total_monthly_excluding_ongoing)) + "/" + row?.frequencyCode_ongoing + " (" + row?.percentageIncrease_ongoing + "%)"}
          </span>,
      sortable: true,
    },

    // {
    //   name: "DRIVERS",
    //   width: "20%",
    //   selector: (row) => row?.driverOrder,

    //   cell: (row) => (
    //     <>
    //       {row?.driverOrder
    //         ?.filter((d) => d && d?.value?.trim() !== "")
    //         .map((d, i) => (
    //           <span key={i} className="driver" title={d?.key?.charAt(0).toUpperCase() + d?.key?.slice(1)}>
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="24"
    //               height="24"
    //               viewBox="0 0 24 24"
    //               fill="none"
    //               stroke="currentColor"
    //               strokeWidth="2"
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //             >
    //               <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
    //               <polyline points="16 7 22 7 22 13"></polyline>
    //             </svg>
    //             {d?.value}
    //           </span>
    //         ))}
    //     </>
    //   ),
    //   sortable: true,
    // },
    {
      name: "Next Review",
      width: "12%",
      selector: (row) => row.nextReview,
      sortable: true,
      sortFunction: (a, b) => {
        const dateA = new Date(a?.nextReview || 0).getTime();
        const dateB = new Date(b?.nextReview || 0).getTime();
        return dateA - dateB;
     },
    },
    {
      name: "Actions",
      width: "10%",
      center: true,
      cell: (row) => (
        <div className="actions"
          style={{ marginLeft: "12px" }}>

          <a
            onClick={() =>
              runComparison(row?.Client?.id, row?.id)
            }
          >
            <GitCompare size={15} />
          </a>

          <a
            style={{ fontWeight: "bold" }}
            onClick={() =>
              navigate("/admin/ViewFeeProtector", {
                state: row,
              })
            }
          >
            <Eye size={14} strokeWidth={3} />
          </a>
        </div>
      ),
    },
  ];

  const handleCardClick = (status) => {
    navigate(`/admin/FeeProtectorList?status=${status}`);
  };

  const runComparison = (client_id, contract_id) => {

    sweetalert2.fire({
      title: "Run Comparison",
      text: "Are you sure you want to run comparison for this contract?",
      showCancelButton: true,
      confirmButtonText: "Yes, Run Comparison",
      cancelButtonText: "No, Cancel",
      customClass: {
        popup: 'my-swal-height',
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const data = {
            agent_id: agent_id,
            user_id: user_id,
            client_id: client_id,
            contract_id: contract_id,
          };
          setLoading(true);
          const res = await runComparisonApi(data);

          if (res?.status === true) {
            setTotalRecords(0);
            setCurrentPage(1);
            setPageSize(10);
            setInputValue('');
            setDebouncedSearch('');
            
            // sweetalert2.fire({
            //   title: "Run Comparison",
            //   text: "Comparison has been successfully run.",
            //   icon: "success",
            //   showConfirmButton: false,
            //   timer: 3000,
            // })
            // return
            Swal.close();
            setLoading(false);
            setTimeout(() => {
              Swal.fire({
            title: "Run Comparison",
             text: "Comparison has been successfully run.",
             icon: "success",
             showConfirmButton: false,
             timer: 3000,
             didClose: async () => {
                  setLoading(true);
                  try {
                    await getAllFeeProtectorFunction();
                  } finally {
                    setLoading(false);
                  }
                }
              });
            }, 200);

          } else {
            setLoading(false);
            sweetalert2.fire({
              icon: "error",
              title: "Error",
              text: res?.message
            })
          }


        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      }
    })
  }


  const formatNumber = (num) => {
    if (num === null || num === undefined) return null;
    return new Intl.NumberFormat("en-GB").format(Number(num));
  };

  const handleExport = async () => {
    setLoading(true);
    let totalData = feeProtectorData;

    const data = {
      agent_id: agent_id,
      user_id: user_id,
      page: 1,
      limit: 100000,
      search: debouncedSearch,
    };
    setLoading(true);
    const res = await getAllFeeProtector(data);
    totalData = res?.data ?? []


    if (totalData.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      setLoading(false);
      return
    }

    const exportData = totalData?.map((row) => ({

      "CLIENT": row?.Client?.client_name || "-",
      "CLIENT MANAGER": row?.Client?.am_name || "-", 
      "STATUS": row?.statusFeeProtector || "-",
      "CURRENT FEE":roundNumber(Number(row?.total_monthly_excluding_ongoing || 0)),
      "CURRENT FEE FREQUENCY": row?.frequencyCode_ongoing || "-",
      "PROPOSED FEE": row?.finalDriverData?.length === 0
        ? "-"
        : roundNumber(Number(row?.total_monthly_excluding_ongoing_new || 0)),
      "PROPOSED FEE FREQUENCY": row?.frequencyCode_ongoing || "-",
      "FEE GAP":
        row?.finalDriverData?.length === 0
          ? "-"
          : roundNumber(
            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
            roundNumber(row?.total_monthly_excluding_ongoing || 0)
          ),

      "FEE GAP FREQUENCY": row?.frequencyCode_ongoing || "-",
      "FEE GAP PERCENTAGE (%)":row?.finalDriverData?.length === 0 ? "-":row?.percentageIncrease_ongoing || 0,

      "ANNUAL FEE GAP": roundNumber(
            row?.frequencyCodeNumber_ongoing *
            (
              roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
              roundNumber(row?.total_monthly_excluding_ongoing || 0)
            )
        ),
      "ANNUAL FEE GAP FREQUENCY": row?.frequencyCode_ongoing || "-",       
      "ANNUAL FEE GAP PERCENTAGE (%)":row?.finalDriverData?.length === 0 ? "-":row?.percentageIncrease_ongoing || 0,   
     
      // "DRIVERS":
      //   row?.driverOrder
      //     ?.filter((d) => d && d?.value?.trim() !== "")
      //     ?.map((d) => d?.value)
      //     ?.join(", ") || "-",

      "NEXT REVIEW": row?.nextReview || "-",
    }));
    setLoading(false);
    downloadCSV(exportData, "FeeProtectorDetails.csv");
  };

  const downloadCSV = (data, filename) => {
    if (!data || !data.length) return;
    const headers = Object.keys(data[0]);
    const csvRows = [];
    // HEADER
    csvRows.push(headers.join(","));
    // BODY
    data.forEach((row) => {
      const values = headers.map((header) => {
        let value = row[header] ?? "";
        // double quotes escape
        value = String(value).replace(/"/g, '""');
        return `"${value}"`;
      });
      csvRows.push(values.join(","));
    });
    const csvString = csvRows.join("\n");
    // UTF-8 BOM ADD
    const csvWithBom = "\uFEFF" + csvString;
    const blob = new Blob(
      [csvWithBom],
      {
        type: "text/csv;charset=utf-8;",
      }
    );
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleExportPDF = async () => {
    setLoading(true);
    let totalData = feeProtectorData;

    const data = {
      agent_id: agent_id,
      user_id: user_id,
      page: 1,
      limit: 100000,
      search: debouncedSearch,
    };
    setLoading(true);
    const response = await getAllFeeProtector(data);
    totalData = response?.data ?? []


    if (!response?.status || response?.data?.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      setLoading(false);
      return;
    }

    const formattedData = response?.data?.map((row) => ({

      "Client": row?.Client?.client_name || "-",
      "Client Manager": row?.Client?.am_name || "-", 
      "Status": row?.statusFeeProtector || "-",
      "Current Fee":roundNumber(Number(row?.total_monthly_excluding_ongoing || 0)),
      "Proposed Fee": row?.finalDriverData?.length === 0
        ? "-"
        : roundNumber(Number(row?.total_monthly_excluding_ongoing_new || 0)),
      "Fee Gap":
        row?.finalDriverData?.length === 0
          ? "-"
          : roundNumber(
            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
            roundNumber(row?.total_monthly_excluding_ongoing || 0)
          ),

      "Annual Fee Gap": roundNumber(
            row?.frequencyCodeNumber_ongoing *
            (
              roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
              roundNumber(row?.total_monthly_excluding_ongoing || 0)
            )
        ),
      "Frequency": row?.frequencyCode_ongoing || "-",   
      "Percentage (%)":row?.finalDriverData?.length === 0 ? "-":row?.percentageIncrease_ongoing || 0,   
      "Next Review": row?.nextReview || "-",
    }));



    const res = await axios.post(
      Config.base_url + "export-contract-pdf",
      { data: formattedData, type: "feeProtector" },
      { responseType: "blob" }
    );

    setLoading(false);

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "FeeProtectorDetails.pdf";
    a.click();
  };


  console.log("isLoading", isLoading);
 

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",

        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  
 
  return (
    <div className="config-setting-container">


      <section className="section">
        <div>
          {/* HEADER */}
          <div className="Protector-header">
            <h4 className='page-title' style={{ fontSize: '24px' }}>Fee Protector</h4>
            <p>
              Client fee review & comparison engine - identify undercharged clients
              and automate requoting.
            </p>
          </div>

          {/* CARDS */}
          <div className="fee-protector-cards">
            
            <div className="fee-protector-card" onClick={() => handleCardClick("due_for_review")} style={{ cursor: "pointer" }}>
              <div className="fee-protector-card-1 me-2">
                <i className="fa fa-clock-o orange"></i>
                <h3 >Due for Review</h3>
              </div>
              <span className="orange ms-2">{statusCounts?.due_for_review?.count || 0}</span>
             

                <div className='Potential-Fee'>
                  <div className="fee-protector-tiles-title">Annual Fee Gap</div>
                   <div className='fee-protector-tiles-value-po'>£{roundNumber(parseFloat(statusCounts?.due_for_review?.total_monthly_excluding_ongoing_new || 0) - parseFloat(statusCounts?.due_for_review?.total_monthly_excluding_ongoing || 0)) || 0}</div>
                </div>
            </div>

            

            <div className="fee-protector-card" onClick={() => handleCardClick("overdue")} style={{ cursor: "pointer" }}>
              <div className="fee-protector-card-2">
                <i className="fa fa-exclamation-triangle red"></i>
                <h3>Overdue for Review</h3>
              </div>
              <span className="red ms-2">{statusCounts?.overdue?.count || 0}</span>
              
              <div className='Potential-Fee'>
                  <div className="fee-protector-tiles-title">Annual Fee Gap</div>
                   <div className='fee-protector-tiles-value-po'>£{roundNumber(parseFloat(statusCounts?.overdue?.total_monthly_excluding_ongoing_new || 0) - parseFloat(statusCounts?.overdue?.total_monthly_excluding_ongoing || 0)) || 0}</div>
                </div>
            </div>

            

            <div className="fee-protector-card" onClick={() => handleCardClick("threshold_breach")} style={{ cursor: "pointer" }}>
              <div className="fee-protector-card-3">
                <i className="fa fa-exclamation-triangle red"></i>
                <h3>Threshold Breach</h3>
              </div>
              <span className="red ms-2">{statusCounts?.threshold_breach?.count || 0}</span>
             
              <div className='Potential-Fee'>
                  <div className="fee-protector-tiles-title">Annual Fee Gap</div>
                   <div className='fee-protector-tiles-value-po'>£{roundNumber(parseFloat(statusCounts?.threshold_breach?.total_monthly_excluding_ongoing_new || 0) - parseFloat(statusCounts?.threshold_breach?.total_monthly_excluding_ongoing || 0)) || 0}</div>
                </div>
            </div>

            

           

            <div className="fee-protector-card" onClick={() => handleCardClick("completedContract")} style={{ cursor: "pointer" }}>
              <div className="fee-protector-card-3">
                <i className="fa fa-exclamation-triangle red"></i>
                <h3>Successful Fee Gap Closure</h3>
              </div>
              <span className="green ms-2">{statusCounts?.completedContract || 0}</span>
              <div className='Potential-Fee'>
                  <div className="fee-protector-tiles-title">Annual Fee Gap Closed</div>
                    <div className='fee-protector-tiles-value-po'>£{
                      roundNumber(statusCounts?.total_monthly_ongoing_sum || 0)
                    }</div>
                </div>
            </div>



             <div className="fee-protector-card" onClick={() => handleCardClick("renewal_completed")} style={{ cursor: "pointer" }}>
              <div className="fee-protector-card-3">
                <i className="fa fa-exclamation-triangle red"></i>
                <h3>No Action Required</h3>
              </div>
              <span className="green ms-2">{statusCounts?.renewal_completed || 0}</span>
              {/* <div className='Potential-Fee'>
                  <div className="fee-protector-tiles-title">Annual Fee Gap Closed</div>
                    <div className='fee-protector-tiles-value-po'>£{
                      (parseFloat(statusCounts?.total_monthly_ongoing_sum || 0))?.toFixed(2)
                    }</div>
                </div> */}
            </div>



          </div>

          {/* SEARCH */}
          <div className="d-flex align-items-center justify-content-between mb-3 gap-2">
            <div className="search-box">

              <input
                type="text"
                value={InputValue}
                onChange={handleInputChange}
                placeholder="Search clients..."
              />
            </div>

            <div>

              {feeProtectorData?.length > 0 && (
                <>
                  <button className="btn-outline-pink btn me-2" onClick={handleExportPDF}>
                    <i className="ri-download-2-line"></i> Export PDF
                  </button>

                  <button className="btn-outline-pink btn me-2"
                    onClick={handleExport}
                  >
                    <i className="ri-download-2-line"></i>  Export CSV
                  </button>
                </>
              )}
            </div>
          </div>

          {/* TABLE */}
          <div className="quote-table">
            <Datatable
              columns={columns}
              data={feeProtectorData}
              filter={false}
              onRowClicked={(row) => navigate("/admin/ViewFeeProtector", { state: row })}
          
            />

            {feeProtectorData?.length > 0 && (
              <div>
                {/* <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                /> */}

                {/* <div className="mt-0">
                  <select
                    className="perpage-select"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>ALL</option>
                  </select>
                </div> */}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FeeProtector;



// proposed

// vat remove column
// actual proposed difference